<template>

  <select-input
  :label="label"
  v-model="formData"
  value-key="value"
  label-value="label"
  :placeholder="placeholder"
  :size="size"
  :list="selectData"
  :required="required"
  :disabled="disabled" @change="updated" />

</template>

<script>

export default {
  name: 'select-land-type',

  props: {
    label: {
      type: String,
      default: 'Land Type'
    },
    value: {
      //      type: String,
      required: true
    },
    prop: {
      type: String,
      default: this.label
    },
    size: {
      type: String,
      default: 'normal'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    }
  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      selectData: this.getConfig().selects.landType
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectLandType.vue?3c7a02b2